(function registerLootRateDisplayModeContract(global) {
    "use strict";

    var NORMALIZED = "normalized";
    var DENORMALIZED = "denormalized";
    var RAW_WEIGHT = "rawWeight";
    var VALUES = Object.freeze([
        NORMALIZED,
        DENORMALIZED,
        RAW_WEIGHT,
    ]);

    function parse(value, path) {
        if (!VALUES.includes(value)) {
            throw new TypeError(
                (path || "Loot rate display mode")
                + " must be normalized, denormalized, or rawWeight",
            );
        }
        return value;
    }

    var contract = Object.freeze({
        DENORMALIZED: DENORMALIZED,
        NORMALIZED: NORMALIZED,
        RAW_WEIGHT: RAW_WEIGHT,
        VALUES: VALUES,
        parse: parse,
    });
    global.__fishystuffLootRateDisplayModeContract = contract;
    if (global.window && global.window !== global) {
        global.window.__fishystuffLootRateDisplayModeContract = contract;
    }
})(typeof globalThis === "object" ? globalThis : window);
